import React, {useState, useEffect, useRef} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setNewFileType, setViewAddFileModal, resetUploadState, setSelectedFileToUpload, uploadFile, setFolderToAddFile } from 'features/files/fileSlice'
import ModalCloseButton from 'components/buttons/ModalCloseButton' 
import { toast } from 'react-toastify';
import { HiOutlineCloudUpload } from "react-icons/hi";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel'; 
import SpinnerSmall from 'components/SpinnerSmall'
import {  GoBackButton,FileUploadInput, ButttonWrap, FormWrap, FolderSelect } from 'components/files/files.styled'
import { IoArrowBack } from "react-icons/io5"; 
import { SelectFileBtn ,StyledTextInput, StyledHeading, StyledSubmitButton, UploadModalContainer, InputNameWrap, InputNameWrapChild } from 'components/media/media.styled';
import styled from 'styled-components';
import { FaRegFilePdf } from "react-icons/fa6";
import { useTranslation } from 'react-i18next'

export default function AddFileModal({selectedFileType}) {
    const { t } = useTranslation('files')

    const dispatch = useDispatch()
    const handleClose = () => {
        dispatch(setViewAddFileModal(false))
    }
    const [fileName, setFileName] = useState('')
    const [pdfSelected, setPdfSelected] = useState(null)
    const { profileChurch } = useSelector((state) => state.profileChurch)
    const { user } = useSelector((state) => state.auth)
    const { fileToUpload, collectionFiles, fileUploadLoading, fileUploadSuccess, folderToAddFile} = useSelector((state) => state.file)

    const fileNameRef = useRef(null)
    const urlRef = useRef(null)

    const handleBack = () => {
        dispatch(setNewFileType(null))
    }

    const handleBulletinName = (e) => {
        setFileName(e.target.value)
    }

    const handleSelectFolder = (e) => {
        dispatch(setFolderToAddFile(e.target.value))
    }


    const handlePdfChange = (e) => {
        setPdfSelected(e.target.files[0].name)

        let fileName = e.target.files[0].name
        let fileSize = Math.round((e.target.files[0].size / 1024))
        let fileType = fileName.slice(fileName.lastIndexOf('.')+1)

        
        if(fileType !== 'pdf'){
            setPdfSelected(null)
            return toast.error(t('validation.pdfOnly'))
        }
        if(fileSize >= 12000){
            setPdfSelected(null)
            return toast.error(t('validation.maxSize'))
        }

        dispatch(setSelectedFileToUpload(e.target.files[0]))
    }

    const handleUpload = () => {

        if(fileName.length > 100){
            return toast.error(t('validation.nameTooLong'))
        }
        if(selectedFileType === 'url'){
            // ensure url is valid
            let url = urlRef.current.value
            if(url.length === 0){
                return toast.error(t('validation.enterUrl'))
            }
            if(!url.includes('https')){
                return toast.error(t('validation.validUrl'))
            }
            if(!url.includes('.')){
                return toast.error(t('validation.validUrl'))
            }
        }else{

            if(!fileToUpload){
                return toast.error(t('validation.selectPdf'))
            }

        }


        if(fileName.length === 0){
            return toast.error(t('validation.enterName'))
        }

        let folderIndex = collectionFiles.folders.findIndex(folder => folder._id === folderToAddFile)
        const formData = new FormData();
        formData.append("title", fileNameRef.current.value)  

        if(selectedFileType === 'url'){
            
            formData.append("fileType", 'url')
            formData.append("url", urlRef.current.value)

        }else{

            formData.append("fileType", 'pdf')
            formData.append("file", fileToUpload)
        }
        
        formData.append("folder", folderToAddFile === '' ? '' : folderToAddFile)
        formData.append("folderIndex", folderIndex)
        formData.append("churchId", profileChurch._id)
        formData.append("creatorType", user.isOrganization ? 'Church' : 'User')
        formData.append("creatorName", user.fullName)

        dispatch(uploadFile(formData))
 
    }

    useEffect(() => {
        if(fileUploadSuccess){ 
            dispatch(resetUploadState())
            dispatch(setViewAddFileModal(false))
        }
    }, [fileUploadSuccess])

    return (
        <UploadModalContainer>
            <ModalCloseButton 
                handler={handleClose} 
                size='30px'
                top='10px'
                right='10px'
                />               
                <StyledHeading>{t('addOrUpload')}</StyledHeading>
                <GoBackButton
                    style={{marginTop: "-10px"}}
                    onClick={handleBack}
                    >
                        <IoArrowBack /> 
                        {t('goBack')}
                </GoBackButton>
            <FormWrap style={{ marginTop: "10px"}}> 

                <InputWrap>

                        <StyledTextInput 
                            placeholder={t('fileName')}
                            onChange={handleBulletinName} 
                            ref={fileNameRef}
                            />              
                
 

                    {
                        selectedFileType === 'url' ? 
                        ( 
                            <StyledTextInput
                                ref={urlRef}
                                placeholder={t('enterUrl')}
                                />      
                        )
                        : selectedFileType === 'file' &&
                        (
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
                                <InputNameWrap style={{ marginRight: '10px', width: '310px'}}> 
                                    <InputNameWrapChild width={"150px"}> 
                                        { pdfSelected ? 
                                            (
                                                pdfSelected.slice(0, 18) + (pdfSelected.length > 18 ? '...' : '')
                                            ) 
                                            :  
                                            (<i style={{fontSize: "13px"}}>{t('noFileSelected')}</i>)
                                        }
                                    </InputNameWrapChild>
                                    <FileUploadInput  
                                        hidden 
                                        id="bulletinUpload"  
                                        type="file"  accept=".pdf"  name="file" placeholder={'Ehl'}
                                        onChange={handlePdfChange}
                                        />                     
                                    
                                    <SelectFileBtn htmlFor="bulletinUpload"> 
                                        <FaRegFilePdf />
                                        <span>{t('selectFile')}</span>
                                    </SelectFileBtn>  
                                </InputNameWrap>                          
                            </div> 
                        )
                    }
 
                </InputWrap>


                <FolderSelect>
                    <InputLabel id="demo-simple-select-label">{t('selectFolder')}</InputLabel>

                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{width: '100%'}}
                        value={folderToAddFile}
                        onChange={handleSelectFolder} 
                        >
                            <MenuItem key={'000'} value={''}>{t('rootFolder')}</MenuItem>

                            {
                                collectionFiles.folders.map((folder, index) => (
                                    <MenuItem 
                                        key={folder._id} 
                                        selected={folderToAddFile === folder._id}
                                        value={folder._id}
                                        >
                                            {folder.title}
                                    </MenuItem>
                                ))
                            }
                    </Select>
                </FolderSelect>


                <ButttonWrap>
                    <StyledSubmitButton 
                        disabled={fileUploadLoading}
                        onClick={handleUpload}
                        canSubmit={ !fileUploadLoading }
                        >
                            {
                                fileUploadLoading ? (
                                    <SpinnerSmall />
                                )
                                :
                                (
                                    <> 
                                        <span>{t('upload')}</span>
                                    </>
                                )
                            }


                    </StyledSubmitButton>
                </ButttonWrap>
            </FormWrap>
        </UploadModalContainer>
    )
}


const InputWrap = styled.div`
    width: 100%;
    display: flex;  
    flex-direction: column;
    gap: 10px;
    margin-top: 15px;
`
